<template>
  <div class="animated fadeIn card" v-if="show">
    <div class="card-header">
      <h1>Configurações</h1>
    </div>

    <div class="card-body w-100" style="margin-top: 20px;">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <div class="card-box">
          <!-- Endereços de e-mail -->
          <div class="w-100 mb-4">
            <h3>Endereços de email</h3>

            <p>
              Informe os emails para cada contexto inserindo até cinco endereçoes de email separados por ";". Caso os nenhum email seja informado, todos os usuários admin receberão emails.
            </p>

            <div class="row">
              <b-form-group id="group"
                class="col-12"
                label="Contatos"
                label-for="contact_receivers"
                description="Os endereços de email inseridos aqui receberão os contatos realizados pelo site.">

                <b-form-input id="contact_receivers"
                  type="text"
                  v-model="form.contact_receivers"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('contact_receivers'),
                    'is-valid': submitted && !form.errors.has('contact_receivers')
                  }"></b-form-input>
              </b-form-group>

              <b-form-group id="group"
                class="col-12"
                label="Trabalhe Conosco"
                label-for="career_contact_receivers"
                description="Os endereços de email inseridos aqui receberão notificações dos currículos recebidos pelo site.">

                <b-form-input id="career_contact_receivers"
                  type="text"
                  v-model="form.career_contact_receivers"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('career_contact_receivers'),
                    'is-valid': submitted && !form.errors.has('career_contact_receivers')
                  }"></b-form-input>
              </b-form-group>

              <b-form-group id="group"
                class="col-12"
                label="Recebimento das notificações de novos usuários para autorizar"
                label-for="authorization_receivers"
                description="Os endereços de email inseridos aqui receberão notificações de usuarios que precisam de autorização para acessaro sistema.">

                <b-form-input id="authorization_receivers"
                  type="text"
                  v-model="form.authorization_receivers"
                  placeholder=""
                  :class="{
                    'is-invalid': submitted && form.errors.has('authorization_receivers'),
                    'is-valid': submitted && !form.errors.has('authorization_receivers')
                  }"></b-form-input>
              </b-form-group>
            </div>
          </div>

          <!-- Endereços -->
          <div class="w-100 mb-4">
            <h3>Endereços</h3>

            <p class="mb-4">
              Informe os dados para cada endereço.
            </p>

            <div class="row">
              <div class="col-lg-6">

                <div class="row">

                  <b-form-group id="group"
                    class="col-12"
                    label="Cidade 1"
                    label-for="rao_title"
                    description="">

                    <b-form-input id="rao_title"
                      type="text"
                      v-model="form.rao_title"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('rao_title'),
                        'is-valid': submitted && !form.errors.has('rao_title')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12"
                    label="Telefone"
                    label-for="rao_phone"
                    description="">

                    <b-form-input id="rao_phone"
                      type="text"
                      v-model="form.rao_phone"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('rao_phone'),
                        'is-valid': submitted && !form.errors.has('rao_phone')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12"
                    label="Endereço"
                    label-for="rao_address"
                    description="">

                    <rich-textarea v-model="form.rao_address"
                      :height="200"
                      name="rao_address"
                      :toolbar="[
                        ['font', ['bold', 'italic', 'underline', 'clear']],
                        ['insert', ['link']]
                      ]"
                      ></rich-textarea>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12 col-lg-6"
                    label="Latitude"
                    label-for="rao_latitude"
                    description="">

                    <b-form-input id="rao_latitude"
                      type="text"
                      v-model="form.rao_latitude"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('rao_latitude'),
                        'is-valid': submitted && !form.errors.has('rao_latitude')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12 col-lg-6"
                    label="Longitude"
                    label-for="rao_longitude"
                    description="">

                    <b-form-input id="rao_longitude"
                      type="text"
                      v-model="form.rao_longitude"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('rao_longitude'),
                        'is-valid': submitted && !form.errors.has('rao_longitude')
                      }"></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="col-lg-6">

                <div class="row">

                  <b-form-group id="group"
                    class="col-12"
                    label="Cidade 2"
                    label-for="sap_title"
                    description="">

                    <b-form-input id="sap_title"
                      type="text"
                      v-model="form.sap_title"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('sap_title'),
                        'is-valid': submitted && !form.errors.has('sap_title')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12"
                    label="Telefone"
                    label-for="sap_phone"
                    description="">

                    <b-form-input id="sap_phone"
                      type="text"
                      v-model="form.sap_phone"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('sap_phone'),
                        'is-valid': submitted && !form.errors.has('sap_phone')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12"
                    label="Endereço"
                    label-for="sap_address"
                    description="">

                    <rich-textarea v-model="form.sap_address"
                      :height="200"
                      name="sap_address"
                      :toolbar="[
                        ['font', ['bold', 'italic', 'underline', 'clear']],
                        ['insert', ['link']]
                      ]"
                      ></rich-textarea>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12 col-lg-6"
                    label="Latitude"
                    label-for="sap_latitude"
                    description="">

                    <b-form-input id="sap_latitude"
                      type="text"
                      v-model="form.sap_latitude"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('sap_latitude'),
                        'is-valid': submitted && !form.errors.has('sap_latitude')
                      }"></b-form-input>
                  </b-form-group>

                  <b-form-group id="group"
                    class="col-12 col-lg-6"
                    label="Longitude"
                    label-for="sap_longitude"
                    description="">

                    <b-form-input id="sap_longitude"
                      type="text"
                      v-model="form.sap_longitude"
                      placeholder=""
                      :class="{
                        'is-invalid': submitted && form.errors.has('sap_longitude'),
                        'is-valid': submitted && !form.errors.has('sap_longitude')
                      }"></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <!-- LGPD -->
          <div class="w-100 mb-4">
            <h3>LGPD</h3>

            <p class="mb-4">
              Informe o textos sobre a política e cookies.
            </p>

            <h5 class="my-3">Políticas de privacidade</h5>

            <div class="row">

              <div class="col-12" style="margin-top: 10px; margin-bottom: 20px;">
                <div class="switch-container">
                  <span class="switch-label mr-1">
                    Status
                  </span>

                  <toggle-button class="mb-0"
                    v-model="form.privacy_policy_status"
                    :width="70"
                    :height="25"
                    :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
                </div>
              </div>

              <b-form-group id="group"
                class="col-12"
                label="Texto"
                label-for="privacy_policy_text"
                description="">

                <rich-textarea v-model="form.privacy_policy_text"
                  :height="200"
                  name="privacy_policy_text"
                  :toolbar="[
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['insert', ['link']]
                  ]"
                  ></rich-textarea>
              </b-form-group>

            </div>

            <h5 class="my-3">Alerta Cookies</h5>

            <div class="row">

              <div class="col-12" style="margin-top: 10px; margin-bottom: 20px;">
                <div class="switch-container">
                  <span class="switch-label mr-1">
                    Status
                  </span>

                  <toggle-button class="mb-0"
                    v-model="form.cookies_status"
                    :width="70"
                    :height="25"
                    :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
                </div>
              </div>

              <b-form-group id="group"
                class="col-12"
                label="Texto"
                label-for="cookies_text"
                description="">

                <rich-textarea v-model="form.cookies_text"
                  :height="200"
                  name="cookies_text"
                  :toolbar="[
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['insert', ['link']]
                  ]"
                  ></rich-textarea>
              </b-form-group>

            </div>
          </div>

          <!-- Submit -->
          <div class="text-right">
            <b-button type="submit" variant="success">
              Atualizar
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { resolveHTTP } from '@/services/api'
import Form from '@/services/form'

export default {
  data () {
    return {
      show: true,
      processing: false,
      submitted: false,

      http: null,

      form: new Form({}, { resetOnSuccess: false }),
      empty: {
        contact_receivers: '',
        career_contact_receivers: '',
        authorization_receivers: '',
        rao_title: '',
        rao_phone: '',
        rao_address: '',
        rao_latitude: '',
        rao_longitude: '',
        sap_title: '',
        sap_phone: '',
        sap_address: '',
        sap_latitude: '',
        sap_longitude: '',
        privacy_policy_status: true,
        privacy_policy_text: '',
        cookies_status: true,
        cookies_text: ''
      }
    }
  },

  methods: {
    ...mapActions({
      clearError: 'errors/clearError'
    }),

    setFormData (data) {
      this.form = new Form({
        contact_receivers: data.contact_receivers || '',
        career_contact_receivers: data.career_contact_receivers || '',
        authorization_receivers: data.authorization_receivers || '',
        rao_title: data.rao_title || '',
        rao_phone: data.rao_phone || '',
        rao_address: data.rao_address || '',
        rao_latitude: data.rao_latitude || '',
        rao_longitude: data.rao_longitude || '',
        sap_title: data.sap_title || '',
        sap_phone: data.sap_phone || '',
        sap_address: data.sap_address || '',
        sap_latitude: data.sap_latitude || '',
        sap_longitude: data.sap_longitude || '',
        privacy_policy_status: data.privacy_policy_status ? data.privacy_policy_status === '1' : true,
        privacy_policy_text: data.privacy_policy_text || '',
        cookies_status: data.cookies_status ? data.cookies_status === '1' : true,
        cookies_text: data.cookies_text || ''
      }, { resetOnSuccess: false })
    },

    refresh () {
      const self = this

      self.processing = true
      self.http.index()
        .then((res) => {
          self.processing = false
          self.setFormData(res.data)
          self.show = false
          self.$nextTick(() => { this.show = true })
        }).catch(() => {
          self.processing = false
          self.$toasted.info('Houve um erro receber as configurações')
        })
    },

    onSubmit (evt) {
      const self = this

      self.clearError(['UnprocessableEntity'])

      self.processing = true
      self.submitted = false

      self.form.put(self.http.getRoute('store'))
        .then(([data, res]) => {
          self.submitted = true
          self.processing = false

          self.$toasted.success('Configurações atualizadas com sucesso')
        }).catch((e) => {
          self.submitted = true
          self.processing = false
        })
    },

    onReset (evt) {
      /* Reset our form values */
      this.form.reset()
      this.submitted = false

      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => { this.show = true })
    }
  },

  created () {
    this.http = resolveHTTP('/settings')
  },

  mounted () {
    this.refresh()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Settings.vue